import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import AppNotifService, { TAppNotifs } from "../../services/appNotif.service";
import { TestIds } from "../home/index";
import InfiniteScroll from "react-infinite-scroll-component";
import "./notification.css";
import { ScreenHeader } from "react-library";
import { FaCalendarAlt, FaClock } from "react-icons/fa";
import { t } from "../../services/locale.service";

const Notification = () => {
  const { plotId } = useParams<{ plotId: string }>();
  const [notifications, setNotifications] = useState<TAppNotifs>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [pageIndex, setPageIndex] = useState<number>(0);
  const [hasMore, setHasMore] = useState<boolean>(true);

  const headerTitle = t("Notifications");

  const fetchNotifications = async (page: number) => {
    if (!plotId) {
      setError(t("Plot_ID_is_required"));
      return;
    }

    try {
      const data = await AppNotifService.getLatestFieldData(plotId, page, true);
      if (data?.length === 0) {
        setHasMore(false);
      } else {
        setNotifications((prev) => [...prev, ...data]);
      }
    } catch (err) {
      setError(t("Something_went_wrong"));
    } finally {
      setLoading(false);
    }
  };

  const loadMoreNotifications = useCallback(() => {
    if (hasMore) {
      setPageIndex((prev) => prev + 1);
    }
  }, [hasMore]);

  const handleBack = () => {
    try {
      window.history.back();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchNotifications(pageIndex);
  }, [pageIndex, plotId]);

  useEffect(() => {
    window.addEventListener("back-icon-press", handleBack);

    return () => {
      window.removeEventListener("back-icon-press", handleBack);
    };
  }, []);

  if (loading && notifications?.length === 0) {
    return (
      <div
        data-testid={TestIds?.onboardingLoader}
        style={{ textAlign: "center", padding: 10 }}
      >
        {t("Loading")}
      </div>
    );
  }

  if (error) {
    return <div style={{ color: "red", padding: 10 }}>{error}</div>;
  }

  return (
    <>
      <ScreenHeader screenName={headerTitle} />
      <InfiniteScroll
        dataLength={notifications?.length}
        next={loadMoreNotifications}
        hasMore={hasMore}
        loader={
          <p style={{ textAlign: "center" }}>{t("Loading")}</p>
        }
      >
        <div className="notification-list">
          {notifications?.length > 0 ? (
            notifications.map((notification) => (
              <div className="notification-card" key={notification?.id}>
                <strong>{notification?.text}</strong>
                <div className="notification-datetime">
                  <div className="smalldiv">
                    <FaCalendarAlt className="icon" />{" "}
                    <span className="date">
                      {new Date(notification?.date)?.toLocaleDateString(
                        "en-US",
                        {
                          day: "numeric",
                          month: "long",
                          year: "numeric",
                        }
                      )}
                    </span>
                  </div>
                  <div className="smalldiv">
                    <FaClock className="icon" />
                    <span className="time">
                      {new Date(notification?.date)?.toLocaleTimeString(
                        "en-US",
                        {
                          hour: "numeric",
                          minute: "numeric",
                          hour12: true,
                        }
                      )}{" "}
                    </span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="no-notifications" style={{ textAlign: "center" }}>
              {t("No_notifications_available")}
            </div>
          )}
        </div>
      </InfiniteScroll>
    </>
  );
};

export default Notification;
